export default __webpack_public_path__ + "static/media/storefront.d57131ea.svg";